import React, { forwardRef } from 'react';

const IcStatusGood = forwardRef(
  (properties, ref) => /* @__PURE__ */ React.createElement("svg", {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    ...properties,
    ref
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
    fill: "var(--positive-icon-default)"
  }), /* @__PURE__ */ React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.138 6.195c.26.26.26.683 0 .943l-3.499 3.5a.667.667 0 0 1-.942 0l-1.502-1.5a.667.667 0 1 1 .943-.943l1.03 1.029 3.027-3.029c.26-.26.683-.26.943 0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))
);

export { IcStatusGood };
//# sourceMappingURL=ic-status-good.js.map
